import { render, staticRenderFns } from "./KBMenu.vue?vue&type=template&id=ca4738b8&scoped=true&"
import script from "./KBMenu.vue?vue&type=script&lang=ts&"
export * from "./KBMenu.vue?vue&type=script&lang=ts&"
import style0 from "./KBMenu.vue?vue&type=style&index=0&id=ca4738b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4738b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
